import { render } from "./recruit.vue?vue&type=template&id=8119ef28&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"

import "./recruit.vue?vue&type=style&index=0&id=8119ef28&scoped=true&lang=css"

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8119ef28"]])

export default __exports__